import styled, { css } from "styled-components";

const SvgContainerColorMixin = css<{ $fontColor: string }>`
  path,
  line,
  circle {
    fill: ${({ $fontColor }) => $fontColor};
  }
`;

export const SvgContainer = styled.div<{ $width?: number; $fontColor?: string }>`
  &&& {
    min-width: ${({ $width }) => ($width ? `${$width}px` : "1rem")};
    max-width: ${({ $width }) => ($width ? `${$width}px` : "1rem")};

    ${({ $fontColor }) => !!$fontColor && SvgContainerColorMixin};

    > * {
      min-width: inherit;
    }
  }
`;
